import type React from "react";
import { ReactComponent as Svg } from "./assets/information-circle.svg";
import * as styles from "./Icon.module.scss";

type InfoProps = React.SVGProps<SVGSVGElement>;

export const Info = ({ className, ...props }: InfoProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
